import isEmpty from 'lodash/isEmpty';
import { StatusOption } from '../hooks/useStatusOptions';
import { RfiStatus } from '../sdk';
import { isOneOfOpenStatuses } from './statusHelpers';

const getSelectedTransition = (statusOptions: StatusOption[]) => {
  // Default transition order is open, submitted, draft.
  const openOption = statusOptions.find((option: StatusOption) =>
    isOneOfOpenStatuses(option.serverStatus),
  );

  if (openOption && !isEmpty(openOption.assigneeUsers)) {
    return openOption;
  }
  const submittedOption = statusOptions.find(
    (option: StatusOption) => option.status === RfiStatus.Submitted,
  );
  if (submittedOption && !isEmpty(submittedOption.assigneeUsers)) {
    return submittedOption;
  }

  const draftOption = statusOptions.find(
    (option: StatusOption) => option.serverStatus === RfiStatus.Draft,
  );

  return draftOption;
};

export default getSelectedTransition;
